import React, { Component } from 'react';
import PropTypes from 'prop-types';

import UserMultiSelect from '../UserMultiSelect/UserMultiSelectContainer';

import * as constants from '../../constants/StringConstants';
import * as types from '../../constants/ActionTypes';

/** Used to create a direct message. */
class CreateDM extends Component {
  static propTypes = {
    createDmError: PropTypes.string,
    startDirectMessage: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const defaultInvitedUsers = props.defaultInvitedUsers ? props.defaultInvitedUsers : [];
    this.state = {
      defaultInvitedUsers: [],
      userIds: defaultInvitedUsers,
      enabled: true
    };

    this.props.clearError(types.START_DM);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.createDmError && !state.enabled) {
      return {
        ...state,
        enabled: true
      }
    }
    return state;
  }

  selectedUsers = userIds => this.setState({ userIds });

  clearSelectedUsers = () => this.setState({ userIds: [] });

  startDM = (e) => {
    this.setState({ enabled: false });
    const { userIds } = this.state;
    e.preventDefault();
    userIds.length && this.props.startDirectMessage(userIds);
  };

  render() {
    const { userIds, enabled } = this.state;
    return (
      <form className="create-dm" onSubmit={this.startDM}>
        <label htmlFor='directMessageUserSelection'>{constants.START_CONVERSATION}</label>
        <div className="combined-input">
          <span className="user-select">
            <UserMultiSelect
              id="directMessageUserSelection"
              autoFocus
              qaId="createDirectMessage"
              onChange={this.selectedUsers}
              onClearAll={this.clearSelectedUsers}
              value={userIds}
            />
          </span>
          <button className="btn primary" disabled={!userIds.length || !enabled}>{constants.GO}</button>
        </div>
      </form>
    )
  }
}

export default CreateDM;
